<template>
  <b-form-group
    label="Durum"
    label-for="status"
  >
    <validation-provider
      #default="{ errors }"
      name="Durum"
      rules="required"
    >
      <v-select
        v-model="dataItem.versionOptions.status"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Durum"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'SFilesVOStatusSelectCard',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return [
        {
          id: 'draft',
          title: 'Taslak',
        },
        {
          id: 'alpha',
          title: 'Test / Alpha',
        },
        {
          id: 'released',
          title: 'Yayınlanmış/Kararlı',
        },
        {
          id: 'deprecated',
          title: 'Kullanımdan Kaldırılmış/Eski',
        },
      ]
    },
    dataItem() {
      return this.$store.getters['serviceFiles/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
